// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__T3jYq","file-input":"styles_file-input__9YYos","image":"styles_image__U7lWZ"};